// extracted by mini-css-extract-plugin
module.exports = {"wt7k6mt":"wt7k6mt"};